const validateFileSize = (size, sizeLimitInMb = 5) => {
  const fileSize = size / 1024 / 1024; // in MiB
  if (fileSize > sizeLimitInMb) {
    return false;
  }
  return true;
};

export default validateFileSize;
